module.exports = __webpack_public_path__ + "img/pc-who-are-we-pic.30c87f70.png";